<app-evvtimesheet-list *ngIf="!EvvTimesheetEditList" [ListInputProperty]="isListorUpdateView"
  (ListOutputTimesheet)="EmitChildComponent($event)"></app-evvtimesheet-list>



<app-evvtimesheet-edit *ngIf="EvvTimesheetEditList" [EditInputProperty]="isListorUpdateView"
  (EditOutputTimesheet)="EmitChildComponent($event)"></app-evvtimesheet-edit>